module.exports = __webpack_public_path__ + "static/media/info-gray.86d68579.svg";